import * as types from 'modules/notifications/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {import('../../../types.js').NotificationConfiguration} NotificationConfiguration */

/**
 * @typedef {{
 *   [userId:string]: NotificationConfiguration
 * }} State
 */

/** @type {State} */
const initialState = {};

/**
 * @param {State} state
 * @param {import('../../../types.js').FetchNotificationsConfigurationActionSuccess|import('../../../types.js').PatchNotificationsConfigurationActionSuccess} action
 * @returns {State}
 */
const update = (state, { payload }) => ({
  ...state,
  [payload.userId]: {
    ...(state[payload.userId] ?? {}),
    ...payload.configuration,
  },
});

export default createReducer(initialState, {
  [types.FETCH_CONFIGURATION_SUCCESS]: update,
  [types.PATCH_CONFIGURATION_SUCCESS]: update,
});
